module.exports = __webpack_public_path__ + "img/smarthue.2e4a0aaf.svg";